import { Grid, TextField } from "@material-ui/core";
import { SocItem } from "../../../../domain/SocItem";
import { SectionProps } from "../../../sections/SectionProps";
import { Controller } from "react-hook-form";
import { fieldLabelsOfqual } from "../../../sections/fieldLabels";
import { Error } from "../../../common/Error";

export const CloseDialog: React.FC<SectionProps<SocItem>> = (sectionProps) => {
  const { control, disabled, errors, clearErrors } = sectionProps;

  return (
    <Grid container spacing={3}>
      <Grid xs={12} md={12} lg={12} item>
        Are you sure you want to close this SoC?
      </Grid>
      <Grid xs={12} md={12} lg={12} item>
        <Controller
          control={control}
          name="closeReason"
          rules={{ required: true }}
          render={({ onChange }) => (
            <TextField
              fullWidth
              multiline
              rows={8}
              variant="outlined"
              label={fieldLabelsOfqual.closeReason}
              disabled={disabled}
              data-test="close-reason-field"
              required
              onChange={(e) => {
                if (e.target.value.length > 0) clearErrors("closeReason");
                onChange(e);
              }}
            />
          )}
        />
        {errors.closeReason?.type === "required" && (
          <Error data-test="close-reason-validation">
            This field is required
          </Error>
        )}
      </Grid>
    </Grid>
  );
};
